import React from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";
import { cn } from "../../../utils/cn";

interface ScopeDisplayProps {
  selectedLocationId?: string;
  selectedBuildingId?: string;
  floor?: string;
  locations: any[];
  buildings: any[];
  disabled?: boolean;

}

const ScopeDisplay: React.FC<ScopeDisplayProps> = ({
  selectedLocationId,
  selectedBuildingId,
  floor,
  locations,
  buildings,disabled
}) => {
  const { t } = useTranslation();

  if (!selectedLocationId) return null;

  return (
    <div className={cn("max-w-max flex items-center gap-2 border border-gray-400 rounded-md px-3 py-2 bg-gray-100 text-[15px] font-normal",
      disabled && "opacity-80"
    )}>
      <p>
        {t("location")}:{" "}
        {locations?.find((item) => item.value === Number(selectedLocationId))?.[
          i18n.language === "en" ? "labelEn" : "labelAr"
        ] || ""}
      </p>

      {selectedBuildingId && (
        <>
          <p className="text-gray-400">&gt;</p>
          <p>
            {t("building")}:{" "}
            {buildings?.find(
              (item) => item.value === Number(selectedBuildingId)
            )?.[i18n.language === "en" ? "labelEn" : "labelAr"] || ""}
          </p>
        </>
      )}

      {floor && (
        <>
          <p className="text-gray-400">&gt;</p>
          <p>
            {t("floor")}: {floor}
          </p>
        </>
      )}
    </div>
  );
};

export default ScopeDisplay;